<template>
    <section class="flex-container my-4">
        <div class="flex flex-col gap-2">
            <label for="emailEnvioChecklist">{{ descricao }}</label>
            <Multiselect class="multiselect" name="multiselect" mode="tags" :options="opcoes"
                placeholder="-- Selecione --" />
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';

export default defineComponent({
    name: 'OpcaoMultiplaEscolha',
    components: {
        Multiselect,
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
    --ms-tag-bg: #1D74AF !important;
    --ms-ring-color: #91CAFF !important;
    --ms-ring-width: 2px !important;
}
</style>